import { isImageErrorVar } from 'modulesCommon/store'

export { default as cn } from 'classnames'

export const repeat = (count: number) => Array(count).fill(1)

export const isEqual = (obj1: any, obj2: any) => Object.keys(obj1).every((key) => obj1[key] === obj2[key])

export const isOdd = (num: number): boolean => num % 2 === 1

export const sortById = (a: any, b: any) => Number(a.id) - Number(b.id)

export const isNestedObjEqual = (obj1: any, obj2: any) => JSON.stringify(obj1) === JSON.stringify(obj2)

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

export const abbreviateNumber = (number?: number): string => {
  if (!number) return '--'

  const suffixes = ['', 'K', 'M', 'B', 'T']

  let newValue = number
  let suffixNum = 0

  while (newValue >= 1000) {
    newValue /= 1000
    suffixNum++
  }

  return `${newValue.toPrecision(3)}${suffixes[suffixNum]}`
}

export const isImgTooLarge = (imgFile: File | DataTransferItem, maxSize: number) => {
  if (imgFile instanceof DataTransferItem) {
    const file = imgFile.getAsFile()

    return file && file.size > maxSize
  }

  return imgFile.size > maxSize
}

export const setImageValidationError = () => {
  isImageErrorVar(true)

  setTimeout(() => {
    isImageErrorVar(false)
  }, 3000)
}

export const fileUploadProgressHandler = (acceptedFiles: File[], cb: (n: number) => void) => {
  for (const file of acceptedFiles) {
    cb(0)
    const formData = new FormData()
    const url = process.env.REACT_APP_IMAGES_URL || '/'
    formData.append('file', file)
    const xhr = new XMLHttpRequest()
    xhr.upload.onprogress = (event) => {
      const percentage = (event.loaded / event.total) * 100
      cb(percentage)
    }
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== 4) return
      if (xhr.status !== 200) {
        cb(0)
        console.log('error')
      }
    }
    xhr.open('POST', url, true)
    xhr.send(formData)
  }
}

